import React from 'react';
import cx from 'classnames';
import TitleProps from '../../types/TitleProps';
import style from './Title.module.css';

/**
 * TODO review this component with the documentation from logrocket.
 * ## Show a title with a specific level
 * - `level`: the level of the title (1, 2)
 * - `children`: the text to display
 *
 * @param {level} number
 * @param {children} React.ReactNode
 * @param {css} string[]
 * @returns React.ReactNode
 *
 */
function Title({
  level, children, css, custom, titleSection,
}: TitleProps) {
  const Tag: any = `h${level}`;
  return (
    <Tag
      className={cx(
        css,
        { [style.customTitle]: custom },
        { [style.titleSection]: titleSection },
      )}
      data-testid="title"
    >
      {children}
    </Tag>
  );
}
export default Title;
